export default __webpack_public_path__ + "static/media/contact_whatsapp.be62494d.jpg";